const locales = {
  'ar': {
    dow: 7,
    L: 'D/\u200FM/\u200FYYYY'
  },
  'bg': {
    dow: 2,
    L: 'D.MM.YYYY'
  },
  'ca': {
    dow: 2,
    L: 'DD/MM/YYYY'
  },
  'zh-CN': {
    dow: 2,
    L: 'YYYY/MM/DD'
  },
  'zh-TW': {
    dow: 1,
    L: 'YYYY/MM/DD'
  },
  'hr': {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  'cs': {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  'da': {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  'nl': {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  'en-US': {
    dow: 1,
    L: 'MM/DD/YYYY'
  },
  'en-AU': {
    dow: 2,
    L: 'DD/MM/YYYY'
  },
  'en-CA': {
    dow: 1,
    L: 'YYYY-MM-DD'
  },
  'en-GB': {
    dow: 2,
    L: 'DD/MM/YYYY'
  },
  'en-IE': {
    dow: 2,
    L: 'DD-MM-YYYY'
  },
  'en-NZ': {
    dow: 2,
    L: 'DD/MM/YYYY'
  },
  'eo': {
    dow: 2,
    L: 'YYYY-MM-DD'
  },
  'fi': {
    dow: 2,
    L: 'Do MMMM[ta] YYYY'
  },
  'fr': {
    dow: 2,
    L: 'DD/MM/YYYY'
  },
  'fr-CA': {
    dow: 1,
    L: 'YYYY-MM-DD'
  },
  'fr-CH': {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  'de': {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  'id': {
    dow: 2,
    L: 'DD/MM/YYYY'
  },
  'it': {
    dow: 2,
    L: 'DD/MM/YYYY'
  },
  'ja': {
    dow: 1,
    L: 'YYYY年M月D日'
  },
  'ko': {
    dow: 1,
    L: 'YYYY.MM.DD'
  },
  'mk': {
    dow: 2,
    L: 'D.MM.YYYY'
  },
  'pl': {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  'pt': {
    dow: 2,
    L: 'DD/MM/YYYY'
  },
  'ro': {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  'ru': {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  'sk': {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  'es': {
    dow: 1,
    L: 'DD/MM/YYYY'
  },
  'sv': {
    dow: 2,
    L: 'YYYY-MM-DD'
  },
  'th': {
    dow: 1,
    L: 'DD/MM/YYYY'
  },
  'tr': {
    dow: 2,
    L: 'DD.MM.YYYY'
  },
  'uk': {
    dow: 2,
    L: 'DD.MM.YYYY'
  }
};
locales.en = locales['en-US'];
locales.zh = locales['zh-CN'];
Object.entries(locales).forEach(_ref => {
  let [id, {
    dow,
    L
  }] = _ref;
  locales[id] = {
    firstDayOfWeek: dow,
    masks: {
      L
    }
  };
});
var locales$1 = locales;

export { locales$1 as default };
//# sourceMappingURL=locales.js.map
